import { render, staticRenderFns } from "./journey-synthetic.vue?vue&type=template&id=c62db630&"
import script from "./journey-synthetic.vue.js?vue&type=script&lang=js&"
export * from "./journey-synthetic.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports